module.exports.app_id = "Ghostin.agency";

module.exports.api_url = "";
module.exports.api_token = "";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://localhost:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js